export const decodeToken = (token) => {
  if (!token) {
    return null;
  }
  const base64URL = token.split(".")[1];
  if (!base64URL) {
    return null;
  }

  // Replace URL-safe characters with standard Base64 characters
  let base64 = base64URL.replace(/-/g, "+").replace(/_/g, "/");

  // Add padding if necessary
  while (base64.length % 4) {
    base64 += "=";
  }

  try {
    const decodedString = window.atob(base64);
    const decodedToken = JSON.parse(decodedString);
    return decodedToken;
  } catch (e) {
    console.error("Failed to decode Base64 string:", e);
    return null;
  }
};
